import type { NextPage } from 'next'
import Head from 'next/head'
import { GetStaticProps } from 'next'
import { useRouter } from 'next/router'

// Libs
import { useTranslation } from 'next-i18next'

// Components
import SearchMoreComponent from '@/components/pages/SearchMore'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

// Methods

// Constants
import { envConfigs } from '@/constants/config'
import { DEFAULT_LOCALE } from '@/constants/defaultLocale'
import { ROUTE_PATH } from '@/constants/routePath'

// Styles

// Variables
const Search: NextPage = () => {
  const router = useRouter()
  const { query } = router
  const { t } = useTranslation()
  const { keyword } = query
  const currentLocale = router.locale === 'default' ? DEFAULT_LOCALE : router.locale
  const title = `#${keyword} | ${t('Meta_Title_Search_Merchant', { brandName: 'TutorABC Shop' })}`
  const description = `#${keyword} | ${t('Meta_Description_Search_Merchant', { brandName: 'TutorABC Shop' })}`

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='title' key='meta-title' content={title} />
        <meta name='description' key='meta-description' content={description} />
        <link rel='canonical' href={`${envConfigs.domainUrl}/${currentLocale}${ROUTE_PATH.SEARCH_MERCHANT}?keyword=${keyword || ''}`} />
      </Head>
      <SearchMoreComponent />
    </>
  )
}
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ['common'])),
    },
  }
}

export default Search
